/**
 * Hook for tracking feature usage and user actions with TelemetryDeck.
 *
 * Usage:
 *   const { track } = useTelemetry();
 *   track(EVENTS.CLASS_SUBMITTED, { classId });
 *   track(EVENTS.HELP_ARTICLE_VIEWED, { articleId, category });
 *
 * The `track` function is fire-and-forget — it never throws and never
 * blocks the UI. Import event type constants from @constants/telemetryEvents.
 */

import { useCallback } from 'react';

import { signal } from '@utils/telemetry';

export interface UseTelemetryReturn {
  /**
   * Send a TelemetryDeck signal.
   * @param eventType - Use a constant from EVENTS in @constants/telemetryEvents
   * @param payload   - Optional string key/value metadata
   */
  track: (eventType: string, payload?: Record<string, string>) => void;
}

export function useTelemetry(): UseTelemetryReturn {
  const track = useCallback((eventType: string, payload?: Record<string, string>) => {
    void signal(eventType, payload);
  }, []);

  return { track };
}
